import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import { APIError, ObjectAttribute } from '~bpcommon/lib/types';
import PcardReportExt from '~bpcommon/lib/models/pcard-report';
import { MenuItem, FormControl, InputLabel, FormHelperText} from '@mui/material'
import classNames from 'classnames'
import Popover, {PopoverOrigin} from '@mui/material/Popover';
import {Paper} from '@mui/material';
import {StringAttribute, DateAttribute} from '~bpcommon/lib/types'
import {Grid, TextField, Button, IconButton, Tooltip} from '@mui/material';
import portalUserContext from '~bpcommon/lib/portal-user-context';
import PcardTransactionExt from '~bpcommon/lib/models/pcard-transaction-extended';
import {AddCircle} from "@mui/icons-material"
import AutoSuggest, {AutoSuggestQuery} from '~common/components/autosuggest';
import Autocomplete from "~common/components/autocomplete-field";


import * as request from 'superagent';

 interface Props extends React.HTMLProps<HTMLDivElement>{
    history: any
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
    onCreateReportError: (err: APIError) => void;
    onCreateReportSuccess: (report: PcardReportExt) => void;
    menuItem?: boolean;
    dashboard?: boolean;
    displayAsIcon?: boolean;
    buttonText?: string;
    transactions?: Array<PcardTransactionExt>;
  };
  
  type State = {
    open: boolean;
    reportData: newReportForm;
    saving: boolean;
  };

  const styles = (theme:Theme):StyleRules => ({
    container: {
        width: "100%",
        padding: 10,
        overflow: "auto" 
    },
    controlContainer: {
        padding: 5,
        width: "100%"
    },
    actionButton: {
        float: "right"
    },
    paper: {
        overflow: "auto",
        padding: 10
    },
    searchFieldLabel: {
        whiteSpace: 'nowrap'
    },
    orgField: {
        width: "100%"
    },
    dashboardLink: {
        color: '#0421EA',
        marginTop: 5,
        fontSize: '.7em'
    },
    helperText:{
        color: 'black',
        fontWeight: 600
    },
    popperPaper: {
        width: "100%",
        outline: "none",
        position: "absolute",
        minWidth: "16px",
        maxWidth: "calc(100% - 32px)",
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: "16px",
        marginTop: -100
        // maxHeight: "calc(100% - 32px)"
    }
  });

  class newReportForm {
    reportName: StringAttribute;
    businessPurpose: StringAttribute;
    reportDate: DateAttribute;
    defaultLocation: ObjectAttribute;
    userSelectedLocation: ObjectAttribute;
    constructor(v?: any) {
        this.reportName = new StringAttribute(v.reportName)
        this.businessPurpose = new StringAttribute(v.businessPurpose)
        this.reportDate = new DateAttribute(v.reportDate)
        this.defaultLocation = new ObjectAttribute(v.defaultLocation)
        this.userSelectedLocation = new ObjectAttribute(v.userSelectedLocation)
    }
    public getModelData():any {
        var d:any = {}  
        if(this.reportName) {
            d.reportName = this.reportName.value
        }
        
        if(this.businessPurpose) {
            d.businessPurpose = this.businessPurpose.value
        }
        
        if(this.reportDate) {
            d.reportDate = this.reportDate.value
        }

        if(this.defaultLocation) {
            d.defaultLocation = this.defaultLocation.value
        }

        if(this.userSelectedLocation) {
            d.userSelectedLocation = this.userSelectedLocation.value
        }


        return d
    }
    get modelData():any{
        return this.getModelData()
    }
}

  class AddReportButton extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    anchorEl: any;
    constructor(props:Props & WithStyles<keyof typeof styles>) {
      super(props, {})
      this.state = {
        saving: false,
        open: false,
        reportData: new newReportForm({
            defaultLocation: {
                org: ((window as any).App.userContext.extendedAttributes || {}).org,
                orgDesc: ((window as any).App.userContext.extendedAttributes || {}).orgDesc,
                orgUnit: ((window as any).App.userContext.extendedAttributes || {}).orgUnit,
                orgUnitDesc: ((window as any).App.userContext.extendedAttributes || {}).orgUnitDesc,
                employeeType: ((window as any).App.userContext.extendedAttributes || {}).employeeType,
                operatingType: ((window as any).App.userContext.extendedAttributes || {}).operatingType
            },
            userSelectedLocation: {}
        })
      }; 
    }

    onReportDataChange = (f: any): any => (event: any): void => {
        f.handleChange(event)
        this.setState({});
    }

    togglePopover = () => {
        this.setState({
            open: !this.state.open
        })
    }
    

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    createReport = () => {
        this.setState({saving: true})
        var {reportData} = this.state
        var {userSelectedLocation, defaultLocation} = reportData
        var report = new PcardReportExt({
            title: reportData.reportName.value,
            status: "Unsubmitted",
            extendedAttributes: {
                businessPurpose: reportData.businessPurpose.value,
                ownerFullName: portalUserContext.userContext.displayName,
                createUserFullName: portalUserContext.actionUserFullName,
                createdByProxy: portalUserContext.isProxy ? true : false,
                org: userSelectedLocation.value["org"] || defaultLocation.value["org"],
                orgDesc: userSelectedLocation.value["orgDesc"] || defaultLocation.value["orgDesc"],
                orgUnit: userSelectedLocation.value["orgUnit"] || defaultLocation.value["orgUnit"],
                orgUnitDesc: userSelectedLocation.value["orgUnitDesc"] || defaultLocation.value["orgUnitDesc"],
                employeeType: userSelectedLocation.value["employeeType"] || defaultLocation.value["employeeType"],
                operatingType: userSelectedLocation.value["operatingType"] || defaultLocation.value["operatingType"],
                oopCurrencyType: (window as any).App.userContext.extendedAttributes.oopCurrencyType || "USD"
            },
            ownerID: portalUserContext.userContext.id,
        })
        if (this.props.menuItem && this.props.transactions) {
            report.extendedAttributes.value._transactionIDs = this.props.transactions.map((t: PcardTransactionExt)=>{return t.id.value})
        }
        report.save().then((report: PcardReportExt)=>{
            this.setState({}, () => {
                PcardReportExt.get(Number(report.id.value)).then((report: PcardReportExt)=>{
                    // console.log("saved report", report)
                    if (!report.title.value) {
                        report.title.value = `${portalUserContext.userContext.firstName.substr(0,1)}${portalUserContext.userContext.lastName}${report.id.value}`
                        report.save().then((report: PcardReportExt)=>{
                            this.handleClose()
                            this.props.onCreateReportSuccess(report)
                        }).catch((err: APIError)=>{
                            this.setState({saving: false})
                            console.error(err)
                            this.handleClose()
                            this.props.onCreateReportError(err)
                        })
                    } else {
                        this.handleClose()
                        this.props.onCreateReportSuccess(report)
                    }
                })
            })
        }).catch((err: APIError)=>{
            this.setState({saving: false})
            console.error(err)
            this.handleClose()
            this.props.onCreateReportError(err)
        })
    }

    getLocationPlaceHolder = (field: string) => {
        var {defaultLocation, userSelectedLocation} = this.state.reportData
        if (!userSelectedLocation.value[field]) {
            return defaultLocation.value[`${field}Desc`]
        }
        return ""
    }

    getLocationValue = (field: string) => {
        var {userSelectedLocation} = this.state.reportData
        return userSelectedLocation.value[`${field}Desc`]
    }

    fetchSuggestions = (resource: string, optionKey: string) => (query: AutoSuggestQuery):  Promise<any> => {
        return new Promise((resolve, reject) => {
            request.get(`/api${resource}${query.value}`).then((response: request.Response)=>{
                if (!response.ok) {
                    const apiErr = new APIError()
                    apiErr.type = "api"
                    apiErr.message = "Error Querying Location Data"
                    apiErr.details = response.body.toString()
                    reject(apiErr)
                }
                if (response.body.results && response.body.results.length > 0) {
                    
                    if (optionKey == "org") {
                        resolve(response.body.results.map((i: any)=>{   
                            return {label: `(${i["companyCode"]}) ${i["companyDesc"]}`, value: i["companyCode"]}
                        }))
                    }

                    if (optionKey == "orgUnit") {
                        resolve(response.body.results.map((i: any)=>{   
                            return {label: i["longDesc"], value: i["costCenter"], orgType: i["orgType"], operatingType: i["operatingType"], org: i["companyCode"], orgDesc: `(${i["companyCode"]}) ${i["companyDesc"]}`}
                        }))
                    }

                } else {
                    resolve([])
                }
            }).catch((err)=>{
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error Querying Location Data"
                apiErr.details = (err.response || {text: err.toString()}).text
                reject(apiErr)
            })
        });
    }

    onLocationSelect = (attr: any, field: string, e:any) => (e: any, data: any) => {
        // console.log("onLocationSelect", data)
        var {userSelectedLocation} = this.state.reportData
        if (data && data.suggestionValue && data.suggestionValue.value) {
            
            if (field == "org") {
                userSelectedLocation.value["org"] = data.suggestionValue.value
                userSelectedLocation.value["orgDesc"] = data.suggestionValue.label
                userSelectedLocation.value["orgUnit"] = undefined
                userSelectedLocation.value["orgUnitDesc"] = undefined
            }

            if (field == "orgUnit") {
                userSelectedLocation.value["orgUnit"] = data.suggestionValue.value
                userSelectedLocation.value["orgUnitDesc"] = data.suggestionValue.label
                userSelectedLocation.value["employeeType"] = data.suggestionValue.orgType
                userSelectedLocation.value["org"] = data.suggestionValue.org
                userSelectedLocation.value["orgDesc"] = data.suggestionValue.orgDesc
                userSelectedLocation.value["operatingType"] = data.suggestionValue.operatingType
            }

            this.setState({})


        } else {

            if (field == "org") {
                userSelectedLocation.value["org"] = undefined
                userSelectedLocation.value["orgDesc"] = undefined
                userSelectedLocation.value["orgUnit"] = undefined
                userSelectedLocation.value["orgUnitDesc"] = undefined
                userSelectedLocation.value["employeeType"] = undefined
            }

            if (field == "orgUnit") {
                userSelectedLocation.value["orgUnit"] = undefined
                userSelectedLocation.value["orgUnitDesc"] = undefined
                userSelectedLocation.value["employeeType"] = undefined
                userSelectedLocation.value["org"] = undefined
                userSelectedLocation.value["orgDesc"] = undefined
                userSelectedLocation.value["operatingType"] = undefined
            }

            this.setState({})
            
        }

    }

    render() {
        const { classes }: { classes:ClassNameMap } = this.props
        const {className, anchorOrigin, transformOrigin, menuItem, dashboard, displayAsIcon} = this.props
        const {open, reportData, saving } = this.state

        var ao: PopoverOrigin = {
            horizontal: "left",
            vertical: "bottom"
        }
        if (anchorOrigin) {
            ao = anchorOrigin
        }

        var to: PopoverOrigin = {
            horizontal: "right",
            vertical: "top"
        }
        if (transformOrigin) {
            to = transformOrigin
        }

        return (
            <div>
                {!menuItem && !dashboard && <Button  
                    className={classNames(className, classes.button)} 
                    color="primary"
                    variant="contained"
                    onClick={this.togglePopover} 
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    >
                    {/* <AddCircle/> */}
                    {this.props.buttonText || "Create Report"}
                </Button>}
                {displayAsIcon && dashboard && <Tooltip title="Create Report"><IconButton  
                    className={classNames(className, classes.button)} 
                    color="primary"
                    onClick={this.togglePopover} 
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    >
                    <AddCircle/>
                </IconButton></Tooltip>}
                {!displayAsIcon && dashboard && <Button  
                    className={classNames(className, classes.dashboardLink)} 
                    onClick={this.togglePopover} 
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    >
                    {this.props.buttonText || "Create Report"}
                </Button>}
                {menuItem && <MenuItem
                        className={classes.reportOption}
                        value={"new"}
                        key={"new"}
                        ref={node => {
                            this.anchorEl = node;
                        }}
                        onClick={this.togglePopover} 
                    >
                        (New Report)
                </MenuItem>}
                <Popover
                    open={open}
                    anchorEl={this.anchorEl}
                    anchorReference={"anchorEl"}
                    anchorPosition={{ top: 200, left: 400 }}
                    onClose={this.handleClose}
                    anchorOrigin={ao}
                    transformOrigin={to}
                    PaperProps={{
                        className: classes.popperPaper
                    }}
                >
                    <Paper className={classes.paper}>
                        <Grid className={classes.container} container spacing={3}>
                            <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    autoFocus
                                    name="reportName"
                                    required={false}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    value={reportData.reportName.value}
                                    label={"Report Name"}
                                    InputProps={{
                                        placeholder: `${portalUserContext.userContext.firstName.substr(0,1)}${portalUserContext.userContext.lastName}[Report ID]`
                                    }}
                                    className={classes.controlContainer}
                                    onChange={this.onReportDataChange(reportData.reportName)}
                                    error={false}
                                    helperText={<span className={classes.helperText}>Report Name to be used for a new report.  A Report name will default if one is not provided.</span>}
                                    disabled={false}
                                />
                            </Grid>  
                            <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TextField
                                    required={false}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="businessPurpose"
                                    value={reportData.businessPurpose.value}
                                    label={"Business Purpose"}
                                    className={classes.controlContainer}
                                    onChange={this.onReportDataChange(reportData.businessPurpose)}
                                    error={false}
                                    helperText={<span className={classes.helperText}>Providing a Business Purpose here will be appled to transactions which are assigned to the report and do not have a Business Purpose.</span>}
                                    disabled={false}
                                />
                            </Grid>

                            <Grid item className={classes.gridItem} xs={6} sm={6} md={6} lg={6} xl={6}>
                                <FormControl className={classes.orgField}>
                                    <InputLabel shrink className={classes.searchFieldLabel} required={false}>{"Charge to Location"}</InputLabel>
                                    {/* <Autocomplete
                                        onDirectUpdate={this.onLocationSelect(reportData.userSelectedLocation, "orgUnit", this)}  
                                        // title={fd.title}
                                        // onAccessRootData={onAccessRootData}
                                        // className={classNames(formDefClass, classes.autocomplete)}
                                        type={"Relation"}
                                        // mode={fd.mode}
                                        // data={data}
                                        // error={errorTextVal}
                                        // shrink={shrink}
                                        fieldDefinition={{}}
                                        // helpText={helperText}
                                        classes={{}}
                                        value={this.getLocationValue("orgUnit") || ''}
                                        autoSuggestUrl={`/api/pcard/org-units/search?org=${reportData.userSelectedLocation.value["org"] || reportData.defaultLocation.value["org"]}`}
                                        // appendToQuery={fd.appendToQuery}
                                        // disabled={fd.mode == "Read Only" || this.props.readOnly}
                                    /> */}
                                    
                                    <AutoSuggest
                                        displayClearAdornment={true}
                                        emitClear={true}
                                        maxHeight={200}
                                        modal={false}
                                        name="orgUnit"
                                        minQueryChars={2}
                                        preventBusyTab={true}
                                        autoSelectOptions={false}
                                        classes={{}}
                                        placeholder={this.getLocationPlaceHolder("orgUnit")}
                                        value={this.getLocationValue("orgUnit") || ''}
                                        fetchSuggestions={this.fetchSuggestions(`/pcard/org-units/search?org=${reportData.userSelectedLocation.value["org"] || reportData.defaultLocation.value["org"]}&term=`, "orgUnit")}
                                        onSuggestionSelected={this.onLocationSelect(reportData.userSelectedLocation, "orgUnit", this)}
                                        disabled={false}
                                    >
                                    </AutoSuggest>
                                    <FormHelperText>{(reportData.userSelectedLocation || {}).value.orgDesc || (reportData.defaultLocation || {}).value.orgDesc || ''}</FormHelperText>
                                    <FormHelperText ><span className={classes.helperText}>Enter the Location you want to charge against.</span></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item className={classes.gridItem} xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Button disabled={saving} className={classes.actionButton} variant="contained" color="secondary" onClick={this.createReport}>Create Report</Button>
                            </Grid> 
                        </Grid>
                
                    </Paper>
                </Popover>
														
            </div>
        )
    }
}

export default withStyles(styles)(AddReportButton);